import { forwardRef } from "react";
import { cn } from "@/agents-v2/utils/cn";
import { SlashGlyph } from "./prompt-recipes-popup";

interface RecipeChipProps {
  /** The recipe title shown in the chip. */
  title: string;
  /** Extra classes (positioning, alignment) for the chip wrapper. */
  className?: string;
}

/**
 * The selected-skill chip: a "/" keycap followed by the recipe title (matches
 * the design mockup). Used both inline in the composer and in the sent
 * user-message bubble. Presentational only — callers handle positioning.
 */
export const RecipeChip = forwardRef<HTMLSpanElement, RecipeChipProps>(
  ({ title, className }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex flex-shrink-0 items-center gap-2 text-base leading-relaxed",
        className
      )}
    >
      <span className="flex h-5 w-5 items-center justify-center rounded-md border border-border bg-background text-muted-foreground">
        <SlashGlyph />
      </span>
      <span className="whitespace-nowrap">{title}</span>
    </span>
  )
);

RecipeChip.displayName = "RecipeChip";
